import { Goal } from '@griply/types';

import { buildGoalTree, GoalTreeNode } from './goals/build-goal-tree';
import { sortGoals } from './sort-goals';

// Completed goals stay selectable — their tasks must remain findable via the goal filter.
export const buildGoalFilterOptionTree = (goals: Goal[]): GoalTreeNode[] => {
  const candidates = goals.filter((goal) => !goal.archivedAt && !goal.frozenAt);

  const sortChildren = (
    nodes: GoalTreeNode[],
    parent: Goal,
  ): GoalTreeNode[] => {
    const order = new Map(
      sortGoals(
        nodes.map(({ goal }) => goal),
        {
          allGoals: candidates,
          sortMode: parent.goalSortingMode,
          customOrder: parent.goalSorting,
        },
      ).map((goal, index) => [goal.id, index]),
    );

    return nodes
      .slice()
      .sort((a, b) => (order.get(a.goal.id) ?? 0) - (order.get(b.goal.id) ?? 0))
      .map((node) => ({
        goal: node.goal,
        children: sortChildren(node.children, node.goal),
      }));
  };

  return buildGoalTree(candidates).map((node) => ({
    goal: node.goal,
    children: sortChildren(node.children, node.goal),
  }));
};
